export const giftWrappingMap = [
    { value: "None", id: 0, price: 0, },
    { value: "Birthday", id: 0, price: 10, },
    { value: "Christmas", id: 0, price: 10, },
]